import React, { HTMLInputTypeAttribute } from 'react';

import ValidationAlert from '@/components/common/ValidationAlert/ValidationAlert';

import styles from './contract-input.module.scss';
import Input from '@/components/common/Input/Input';

interface IContractInputHeaderItemProps {
  id?: string;
  label: string;
  placeholder?: string;
  required?: boolean;
  onChange: (value: string) => void;
  value?: any;
  errorMessage?: any;
  type?: HTMLInputTypeAttribute;
  min?: number;
  max?: number;
  step?: number;
}

export default function ContractInputHeaderItem({
  id,
  label,
  placeholder,
  required = false,
  onChange,
  value,
  errorMessage,
  type = 'text',
  min,
  max,
  step,
}: IContractInputHeaderItemProps) {
  return (
    <div>
      <div className={styles['ag-contract-input']}>
        <label className={styles.label} htmlFor={id}>
          {`${label} `}
          {required && <span>*</span>}
        </label>
        <div className={styles.wrapper}>
          <Input
            min={min}
            max={max}
            step={step}
            type={type}
            id={id}
            value={value}
            placeholder={placeholder}
            onChange={(e) => onChange(e.target.value)}
          />
        </div>
      </div>
      {errorMessage ? (
        <ValidationAlert isFloating={false} type="danger">
          <>{errorMessage}</>
        </ValidationAlert>
      ) : null}
    </div>
  );
}
